import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Admin translations
const resources = {
  en: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        appointments: 'Appointments',
        calendar: 'Calendar',
        providers: 'Providers',
        procedures: 'Procedures',
        operatories: 'Operatories',
        reports: 'Reports',
        settings: 'Settings',
        logout: 'Logout'
      },
      
      // Authentication
      auth: {
        login: 'Login',
        username: 'Username',
        password: 'Password',
        loginButton: 'Sign In',
        loginError: 'Invalid username or password',
        welcome: 'Welcome to SeaDent Admin',
        pleaseLogin: 'Please sign in to continue'
      },
      
      // Calendar
      calendar: {
        title: 'Appointment Calendar',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        today: 'Today',
        previous: 'Previous',
        next: 'Next',
        noEvents: 'No appointments',
        filterBy: 'Filter by',
        allProviders: 'All Providers',
        allProcedures: 'All Procedures',
        allOperatories: 'All Operatories',
        refresh: 'Refresh'
      },
      
      // Appointments
      appointments: {
        title: 'Appointments',
        patient: 'Patient',
        provider: 'Provider',
        procedure: 'Procedure',
        operatory: 'Operatory',
        date: 'Date',
        time: 'Time',
        status: 'Status',
        notes: 'Notes',
        language: 'Language',
        actions: 'Actions',
        edit: 'Edit',
        cancel: 'Cancel',
        delete: 'Delete',
        view: 'View Details',
        create: 'Create Appointment',
        update: 'Update Appointment',
        confirm: 'Confirm',
        completed: 'Mark Completed',
        noShow: 'Mark No-Show'
      },
      
      // Status values
      status: {
        scheduled: 'Scheduled',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled',
        completed: 'Completed',
        no_show: 'No Show'
      },
      
      // Providers
      providers: {
        title: 'Providers',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        specialization: 'Specialization',
        active: 'Active',
        appointments: 'Appointments',
        addProvider: 'Add Provider',
        editProvider: 'Edit Provider'
      },
      
      // Procedures
      procedures: {
        title: 'Procedures',
        name: 'Name',
        description: 'Description',
        duration: 'Duration (min)',
        color: 'Color',
        active: 'Active',
        addProcedure: 'Add Procedure',
        editProcedure: 'Edit Procedure'
      },
      
      // Operatories
      operatories: {
        title: 'Operatories',
        name: 'Name',
        description: 'Description',
        active: 'Active',
        availability: 'Availability',
        addOperatory: 'Add Operatory',
        editOperatory: 'Edit Operatory'
      },
      
      // Common
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        view: 'View',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        clear: 'Clear',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        selectDate: 'Select Date',
        selectTime: 'Select Time',
        required: 'Required',
        optional: 'Optional'
      },
      
      // Messages
      messages: {
        appointmentCreated: 'Appointment created successfully',
        appointmentUpdated: 'Appointment updated successfully',
        appointmentCancelled: 'Appointment cancelled successfully',
        appointmentDeleted: 'Appointment deleted successfully',
        confirmDelete: 'Are you sure you want to delete this appointment?',
        confirmCancel: 'Are you sure you want to cancel this appointment?',
        googleCalendarSync: 'Syncing with Google Calendar...',
        googleCalendarSynced: 'Google Calendar synchronized successfully',
        conflictDetected: 'Scheduling conflict detected',
        noConflicts: 'No conflicts found'
      }
    }
  },
  de: {
    translation: {
      nav: {
        dashboard: 'Dashboard',
        appointments: 'Termine',
        calendar: 'Kalender',
        providers: 'Behandler',
        procedures: 'Behandlungen',
        operatories: 'Räume',
        reports: 'Berichte',
        settings: 'Einstellungen',
        logout: 'Abmelden'
      },
      
      auth: {
        login: 'Anmelden',
        username: 'Benutzername',
        password: 'Passwort',
        loginButton: 'Anmelden',
        loginError: 'Ungültiger Benutzername oder Passwort',
        welcome: 'Willkommen bei SeaDent Admin',
        pleaseLogin: 'Bitte melden Sie sich an, um fortzufahren'
      },
      
      calendar: {
        title: 'Terminkalender',
        month: 'Monat',
        week: 'Woche',
        day: 'Tag',
        today: 'Heute',
        previous: 'Vorherige',
        next: 'Nächste',
        noEvents: 'Keine Termine',
        filterBy: 'Filtern nach',
        allProviders: 'Alle Behandler',
        allProcedures: 'Alle Behandlungen',
        allOperatories: 'Alle Räume',
        refresh: 'Aktualisieren'
      },
      
      appointments: {
        title: 'Termine',
        patient: 'Patient',
        provider: 'Behandler',
        procedure: 'Behandlung',
        operatory: 'Raum',
        date: 'Datum',
        time: 'Zeit',
        status: 'Status',
        notes: 'Notizen',
        language: 'Sprache',
        actions: 'Aktionen',
        edit: 'Bearbeiten',
        cancel: 'Stornieren',
        delete: 'Löschen',
        view: 'Details anzeigen',
        create: 'Termin erstellen',
        update: 'Termin aktualisieren',
        confirm: 'Bestätigen',
        completed: 'Als erledigt markieren',
        noShow: 'Als nicht erschienen markieren'
      },
      
      status: {
        scheduled: 'Geplant',
        confirmed: 'Bestätigt',
        cancelled: 'Storniert',
        completed: 'Abgeschlossen',
        no_show: 'Nicht erschienen'
      },
      
      providers: {
        title: 'Behandler',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        specialization: 'Spezialisierung',
        active: 'Aktiv',
        appointments: 'Termine',
        addProvider: 'Behandler hinzufügen',
        editProvider: 'Behandler bearbeiten'
      },
      
      procedures: {
        title: 'Behandlungen',
        name: 'Name',
        description: 'Beschreibung',
        duration: 'Dauer (min)',
        color: 'Farbe',
        active: 'Aktiv',
        addProcedure: 'Behandlung hinzufügen',
        editProcedure: 'Behandlung bearbeiten'
      },
      
      operatories: {
        title: 'Behandlungsräume',
        name: 'Name',
        description: 'Beschreibung',
        active: 'Aktiv',
        availability: 'Verfügbarkeit',
        addOperatory: 'Raum hinzufügen',
        editOperatory: 'Raum bearbeiten'
      },
      
      common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        view: 'Anzeigen',
        add: 'Hinzufügen',
        search: 'Suchen',
        filter: 'Filtern',
        clear: 'Löschen',
        loading: 'Lädt...',
        error: 'Fehler',
        success: 'Erfolg',
        confirm: 'Bestätigen',
        yes: 'Ja',
        no: 'Nein',
        close: 'Schließen',
        back: 'Zurück',
        next: 'Weiter',
        previous: 'Vorherige',
        selectDate: 'Datum auswählen',
        selectTime: 'Zeit auswählen',
        required: 'Erforderlich',
        optional: 'Optional'
      },
      
      messages: {
        appointmentCreated: 'Termin erfolgreich erstellt',
        appointmentUpdated: 'Termin erfolgreich aktualisiert',
        appointmentCancelled: 'Termin erfolgreich storniert',
        appointmentDeleted: 'Termin erfolgreich gelöscht',
        confirmDelete: 'Sind Sie sicher, dass Sie diesen Termin löschen möchten?',
        confirmCancel: 'Sind Sie sicher, dass Sie diesen Termin stornieren möchten?',
        googleCalendarSync: 'Synchronisation mit Google Kalender...',
        googleCalendarSynced: 'Google Kalender erfolgreich synchronisiert',
        conflictDetected: 'Terminkonflikt erkannt',
        noConflicts: 'Keine Konflikte gefunden'
      }
    }
  },
  es: {
    translation: {
      nav: {
        dashboard: 'Panel',
        appointments: 'Citas',
        calendar: 'Calendario',
        providers: 'Doctores',
        procedures: 'Tratamientos',
        operatories: 'Salas',
        reports: 'Informes',
        settings: 'Configuración',
        logout: 'Cerrar Sesión'
      },
      
      auth: {
        login: 'Iniciar Sesión',
        username: 'Usuario',
        password: 'Contraseña',
        loginButton: 'Entrar',
        loginError: 'Usuario o contraseña incorrectos',
        welcome: 'Bienvenido a SeaDent Admin',
        pleaseLogin: 'Por favor, inicie sesión para continuar'
      },
      
      calendar: {
        title: 'Calendario de Citas',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        today: 'Hoy',
        previous: 'Anterior',
        next: 'Siguiente',
        noEvents: 'No hay citas',
        filterBy: 'Filtrar por',
        allProviders: 'Todos los Doctores',
        allProcedures: 'Todos los Tratamientos',
        allOperatories: 'Todas las Salas',
        refresh: 'Actualizar'
      },
      
      appointments: {
        title: 'Citas',
        patient: 'Paciente',
        provider: 'Doctor',
        procedure: 'Tratamiento',
        operatory: 'Sala',
        date: 'Fecha',
        time: 'Hora',
        status: 'Estado',
        notes: 'Notas',
        language: 'Idioma',
        actions: 'Acciones',
        edit: 'Editar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        view: 'Ver Detalles',
        create: 'Crear Cita',
        update: 'Actualizar Cita',
        confirm: 'Confirmar',
        completed: 'Marcar como Completada',
        noShow: 'Marcar como No Asistió'
      },
      
      status: {
        scheduled: 'Programada',
        confirmed: 'Confirmada',
        cancelled: 'Cancelada',
        completed: 'Completada',
        no_show: 'No Asistió'
      },
      
      providers: {
        title: 'Doctores',
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        specialization: 'Especialización',
        active: 'Activo',
        appointments: 'Citas',
        addProvider: 'Añadir Doctor',
        editProvider: 'Editar Doctor'
      },
      
      procedures: {
        title: 'Tratamientos',
        name: 'Nombre',
        description: 'Descripción',
        duration: 'Duración (min)',
        color: 'Color',
        active: 'Activo',
        addProcedure: 'Añadir Tratamiento',
        editProcedure: 'Editar Tratamiento'
      },
      
      operatories: {
        title: 'Salas de Tratamiento',
        name: 'Nombre',
        description: 'Descripción',
        active: 'Activo',
        availability: 'Disponibilidad',
        addOperatory: 'Añadir Sala',
        editOperatory: 'Editar Sala'
      },
      
      common: {
        save: 'Guardar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        edit: 'Editar',
        view: 'Ver',
        add: 'Añadir',
        search: 'Buscar',
        filter: 'Filtrar',
        clear: 'Limpiar',
        loading: 'Cargando...',
        error: 'Error',
        success: 'Éxito',
        confirm: 'Confirmar',
        yes: 'Sí',
        no: 'No',
        close: 'Cerrar',
        back: 'Atrás',
        next: 'Siguiente',
        previous: 'Anterior',
        selectDate: 'Seleccionar Fecha',
        selectTime: 'Seleccionar Hora',
        required: 'Requerido',
        optional: 'Opcional'
      },
      
      messages: {
        appointmentCreated: 'Cita creada exitosamente',
        appointmentUpdated: 'Cita actualizada exitosamente',
        appointmentCancelled: 'Cita cancelada exitosamente',
        appointmentDeleted: 'Cita eliminada exitosamente',
        confirmDelete: '¿Está seguro de que desea eliminar esta cita?',
        confirmCancel: '¿Está seguro de que desea cancelar esta cita?',
        googleCalendarSync: 'Sincronizando con Google Calendar...',
        googleCalendarSynced: 'Google Calendar sincronizado exitosamente',
        conflictDetected: 'Conflicto de horario detectado',
        noConflicts: 'No se encontraron conflictos'
      }
    }
  },
  ru: {
    translation: {
      nav: {
        dashboard: 'Панель управления',
        appointments: 'Записи',
        calendar: 'Календарь',
        providers: 'Врачи',
        procedures: 'Процедуры',
        operatories: 'Кабинеты',
        reports: 'Отчеты',
        settings: 'Настройки',
        logout: 'Выйти'
      },
      
      auth: {
        login: 'Войти',
        username: 'Имя пользователя',
        password: 'Пароль',
        loginButton: 'Войти',
        loginError: 'Неверное имя пользователя или пароль',
        welcome: 'Добро пожаловать в SeaDent Admin',
        pleaseLogin: 'Пожалуйста, войдите для продолжения'
      },
      
      calendar: {
        title: 'Календарь записей',
        month: 'Месяц',
        week: 'Неделя',
        day: 'День',
        today: 'Сегодня',
        previous: 'Предыдущий',
        next: 'Следующий',
        noEvents: 'Нет записей',
        filterBy: 'Фильтр по',
        allProviders: 'Все врачи',
        allProcedures: 'Все процедуры',
        allOperatories: 'Все кабинеты',
        refresh: 'Обновить'
      },
      
      appointments: {
        title: 'Записи',
        patient: 'Пациент',
        provider: 'Врач',
        procedure: 'Процедура',
        operatory: 'Кабинет',
        date: 'Дата',
        time: 'Время',
        status: 'Статус',
        notes: 'Заметки',
        language: 'Язык',
        actions: 'Действия',
        edit: 'Редактировать',
        cancel: 'Отменить',
        delete: 'Удалить',
        view: 'Просмотр',
        create: 'Создать запись',
        update: 'Обновить запись',
        confirm: 'Подтвердить',
        completed: 'Отметить как выполненное',
        noShow: 'Отметить как неявку'
      },
      
      status: {
        scheduled: 'Запланировано',
        confirmed: 'Подтверждено',
        cancelled: 'Отменено',
        completed: 'Завершено',
        no_show: 'Неявка'
      },
      
      providers: {
        title: 'Врачи',
        name: 'Имя',
        email: 'Email',
        phone: 'Телефон',
        specialization: 'Специализация',
        active: 'Активный',
        appointments: 'Записи',
        addProvider: 'Добавить врача',
        editProvider: 'Редактировать врача'
      },
      
      procedures: {
        title: 'Процедуры',
        name: 'Название',
        description: 'Описание',
        duration: 'Продолжительность (мин)',
        color: 'Цвет',
        active: 'Активный',
        addProcedure: 'Добавить процедуру',
        editProcedure: 'Редактировать процедуру'
      },
      
      operatories: {
        title: 'Кабинеты',
        name: 'Название',
        description: 'Описание',
        active: 'Активный',
        availability: 'Доступность',
        addOperatory: 'Добавить кабинет',
        editOperatory: 'Редактировать кабинет'
      },
      
      common: {
        save: 'Сохранить',
        cancel: 'Отмена',
        delete: 'Удалить',
        edit: 'Редактировать',
        view: 'Просмотр',
        add: 'Добавить',
        search: 'Поиск',
        filter: 'Фильтр',
        clear: 'Очистить',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успех',
        confirm: 'Подтвердить',
        yes: 'Да',
        no: 'Нет',
        close: 'Закрыть',
        back: 'Назад',
        next: 'Далее',
        previous: 'Предыдущий',
        selectDate: 'Выбрать дату',
        selectTime: 'Выбрать время',
        required: 'Обязательно',
        optional: 'Необязательно'
      },
      
      messages: {
        appointmentCreated: 'Запись успешно создана',
        appointmentUpdated: 'Запись успешно обновлена',
        appointmentCancelled: 'Запись успешно отменена',
        appointmentDeleted: 'Запись успешно удалена',
        confirmDelete: 'Вы уверены, что хотите удалить эту запись?',
        confirmCancel: 'Вы уверены, что хотите отменить эту запись?',
        googleCalendarSync: 'Синхронизация с Google Calendar...',
        googleCalendarSynced: 'Google Calendar успешно синхронизирован',
        conflictDetected: 'Обнаружен конфликт расписания',
        noConflicts: 'Конфликтов не найдено'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    detection: {
      // Store language preference in localStorage
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n; 